export const fileUploadConstants = {
    DELETE: 'DELETE',
    REPLACE: 'REPLACE',
}